import * as React from "react";
import { SVGProps } from "react";
const SvgCommunities = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 18.125c0-4.5 2.4-8.5 6.2-10.6.2.7.4 1.3.8 1.8a10.033 10.033 0 0 0-4.995 8.374L6 18.125c-.7-.1-1.3-.1-2 0Zm12 9.9c-1.9 0-3.9-.6-5.5-1.7l-.262.512c-.226.423-.48.83-.838 1.188 4 2.6 9.1 2.6 13.1 0-.5-.5-.8-1.1-1.1-1.7-1.5 1.1-3.4 1.7-5.4 1.7Zm9.995-10.326.005.326c.7 0 1.3 0 2 .1v-.1c0-4.4-2.4-8.4-6.2-10.5-.2.7-.4 1.3-.8 1.8a10.033 10.033 0 0 1 4.995 8.374ZM16 10.025c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4Zm-11 10c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4Zm22 0c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCommunities;
